/**
 * @generated SignedSource<<6329609dc608db2534fa4843cbc7e49e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReturningBuyerDeliveryOptionsView_deliveryOptions$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_deliveryOptions">;
  readonly " $fragmentType": "CheckoutReturningBuyerDeliveryOptionsView_deliveryOptions";
}>;
export type CheckoutReturningBuyerDeliveryOptionsView_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: CheckoutReturningBuyerDeliveryOptionsView_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReturningBuyerDeliveryOptionsView_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CheckoutReturningBuyerDeliveryOptionsView_deliveryOptions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptions_deliveryOptions"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "bf919d8c1c1f8d34de9db11f94a6afd1";

export default node;
